<style lang="stylus">

@import '../styles/common';
.edit-score-template {
    .player-score {}
    .player {
        margin-top: 1em;
        font-size: 1.3em;
        text-align: center;
    }
    .point {
        font-size: 4.5em;
        font-weight: bold;
        text-align: center;
    }
}

</style>

<template lang="html">

<div class="edit-score-template">
    <div class="player-score" v-if="player" :style="{'color':player.color}">
        <div class="player">{{player.name}}</div>
        <div class="point">{{points}}</div>
    </div>
    <keyboard @keyboardPress="onKeyboardPress"></keyboard>
</div>

</template>

<script>
import gamesStore from './../store/GamesStore'
import Keyboard from './Keyboard.vue'

export default {
  data: function() {
    return {
      playerIndex:0,
      points:0,
      round:[]
    }
  },
  computed: {
    game() {
      return gamesStore.state.currentGame
    },
    player() {
      return this.game && this.game.players ? this.game.players[this.playerIndex] : null
    }
  },
  methods: {
    onKeyboardPress(key) {
      switch (key) {
        case 'valid':
          this.round.push(this.points)
          this.playerIndex++
          this.points = 0
          if (this.playerIndex === this.game.players.length) {
            this.game.addRound(this.round)
            this.playerIndex = 0
            this.round = []
            gamesStore.pushLocalStorage()
            this.$emit('onPopState')
          }
          break;
        case 'erase':
          this.points = Math.floor(this.points * 0.1)
          break;
        default:
          if (this.points === 0) {
            this.points = key
          } else if (this.points < 10) {
            this.points = this.points * 10 + key
          }
      }
    }
  },
  components: {
    'keyboard': Keyboard
  }
}
</script>



// WEBPACK FOOTER //
// EditScore.vue?7da7f618